import { FeatureFlagListElement } from 'types/feature-flags.ts';
import { portalAPI } from './portalAPI';
import { accumulatedQueryWithFilters } from './util/endpointBuilder.ts';

const APITeamsSlice = portalAPI.enhanceEndpoints({ addTagTypes: ['FeatureFlags'] }).injectEndpoints({
    endpoints: (builder) => ({
        getFeatureFlagsWithFilters: accumulatedQueryWithFilters<FeatureFlagListElement>(builder, '/v1/feature-flags', {
            providesTags: ['FeatureFlags'],
        }),
        setFeatureFlagEnabled: builder.mutation<void, { featureCode: string; enabled: boolean }>({
            query: ({ featureCode, enabled }) => ({
                url: `/v1/feature-flags/${encodeURIComponent(featureCode)}`,
                method: 'PUT',
                body: { enabled },
            }),
            invalidatesTags: ['FeatureFlags'],
        }),
    }),
    overrideExisting: false,
});

export const { useLazyGetFeatureFlagsWithFiltersQuery, useSetFeatureFlagEnabledMutation } = APITeamsSlice;
